import { createClient } from 'laboratory-lib';
import experiments from '../experiments.yaml';
import PortalIdParser from 'PortalIdParser';
import { createContext } from 'react';
export const laboratoryClient = createClient({
  experiments: experiments,
  identifiers: {
    portalId: PortalIdParser.get()
  }
});
export const LaboratoryContext = /*#__PURE__*/createContext(null);